
import { useRef, useState } from 'react'

import classNames from 'classnames'

import styles from './product_grid.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Button from './basic/button'
import Image from './basic/image'
import Link from './basic/link'
import ScrollAnimation from './layout/scroll_animation'

function ProductGrid(props) {
	const productGridRef = useRef(null)
	const fields = props.fields
	const [grid, setGrid] = useState({items : fields.items.map(item => { return {...item, itemActive: true, buttonActive: false} })})

	const handleMouseEvent = (el, index) => {
		setGrid({items: (grid.items.map(
			(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, itemActive: item.itemActive, buttonActive: false }
		))})
	}

	return <div ref={productGridRef}>
		<ScrollAnimation styles={styles}>
			<BlockWrapper {...props} className={styles.product_grid}>
				<div className={styles.grid_wrapper}>

				{grid.items && grid.items.map((item, i) => {
						return <div key={i} className={classNames(styles.grid_item, styles[item.grid_style], item.itemActive == true ? styles.active : '')} onMouseEnter={(el) => handleMouseEvent(el, i)} onMouseLeave={(el) => handleMouseEvent(el)}>
							<Link href={item.button_clone.button.url} target={item.button_clone.button.target}>
								{item.title.url && item.grid_style == 'style_3' && <Image className={styles.title} {...item.title} />}
								{item.image.url && <Image className={styles.image} settings={{texture: true}} {...item.image} />}
								{item.enable_banner && <div className={styles.banner}><p className={styles.banner_text}>{item.banner_text}</p></div>}
								<div className={styles.content_wrapper}>
									{item.title.url && item.grid_style != 'style_3' && <Image className={styles.title} {...item.title} />}
									<div className={styles.content} dangerouslySetInnerHTML={{__html: item.content}}></div>
									{item.button_clone.button && 
										<Button className={classNames(styles.button)} active={item.buttonActive}>{item.button_clone.button.title}</Button>
									}
								</div>
							</Link>

						</div>
				})}

				</div>
			</BlockWrapper>
		</ScrollAnimation>
	</div>
}

export default ProductGrid